import React, { FunctionComponent } from "react";
import styles from "./BackgroundGradient.module.scss";
import BackgroundGradientProps from "./BackgroundGradientProps.interface";

import combineClasses from "helpers/combine-classes";
import useWrapperStyles from "./hooks/useWrapperStyles";

const BackgroundGradient: FunctionComponent<BackgroundGradientProps> = (props): JSX.Element => {
    const wrapperStylesElementRef = useWrapperStyles(props);

    return (
        <div className={combineClasses(styles.wrapper, props.className)} ref={wrapperStylesElementRef}></div>
    );
};

export default BackgroundGradient;